import { render, staticRenderFns } from "./MainTabs.vue?vue&type=template&id=b44c7e24&scoped=true"
import script from "./MainTabs.vue?vue&type=script&lang=js"
export * from "./MainTabs.vue?vue&type=script&lang=js"
import style0 from "./MainTabs.vue?vue&type=style&index=0&id=b44c7e24&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44c7e24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\business\\yoyotravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b44c7e24')) {
      api.createRecord('b44c7e24', component.options)
    } else {
      api.reload('b44c7e24', component.options)
    }
    module.hot.accept("./MainTabs.vue?vue&type=template&id=b44c7e24&scoped=true", function () {
      api.rerender('b44c7e24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/main-tabs/MainTabs.vue"
export default component.exports